export const inviteEmailStatuses = {
  1: 'Email invite sent',
  2: 'First email reminder sent',
  3: 'Second email reminder sent',
};
